<template>
  <div id="auth" class="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center">
    <a href="https://staging.forensic-architecture.org/wp-admin">Please Login</a>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="css" scoped>
  @import '../css/variables';

  #auth {
    z-index: 9999;
    background: var(--red);
    color: var(--col-light);
  }
  a {
    color: var(--col-light);
  }
</style>
